
import React, {FC} from 'react';
import Button from 'components/Button';

import * as styles from './styles.module.scss';

type ExpiredProps = {
	onExit: () => void
}

const Expired: FC<ExpiredProps> = ({onExit}) => (
	<div className={styles.wrapper}>
		<div>
			<p>Sorry, you've run out of time.</p>
			<p>
				Close this window to see time slots
				that are still available.
			</p>
		</div>
		<Button variant='light' onClick={onExit}>
			Close
		</Button>
	</div>
);

export default Expired;
